import { twMerge } from "tailwind-merge";
import { Type } from "@themes/pollinator/ui/Type";

export type Props = {
  children?: React.ReactNode;
  className?: string;
  role?: string;
};

export function SchedulingAvailabilityGridHeaderCell({
  children,
  className,
  role,
}: Props) {
  return (
    <div
      className={twMerge("h-6 border-brand-300 !touch-auto", className)}
      role={role}
    >
      <Type variant="h6">{children}</Type>
    </div>
  );
}

export default SchedulingAvailabilityGridHeaderCell;

